import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid';
import { useSelector, useDispatch } from 'react-redux';
import { STEPPER_ADICCIONES } from '../../data/constants';
import { AdiccionesStepper } from '../UI/AdiccionesStepper';
import { AutorizacionesBuscador } from '../../../autorizaciones/Ingreso/AutorizacionesBuscador';
import { 
  cleanAfiliadoSeleccionadoAdicciones, 
  clearAdicciones, 
  setActiveStepAdicciones 
} from '../../../../actions/adicciones/adiccionesActions';
import { AdiccionesDetalleOrden } from './AdiccionesDetalleOrden';
import { AdiccionesDiagnosticoDocumentacion } from './AdiccionesDiagnosticoDocumentacion';
import { AdiccionesComplementoOrden } from './AdiccionesComplementoOrden';
import { AdiccionesPracticas } from './AdiccionesPracticas';
import { AdiccionesDatosTitular } from './AdiccionesDatosTitular';

export const AdiccionesIngresoHome = ({ fromGestion }) => { 
  const dispatch = useDispatch();

  const { activeStep = 0 } = useSelector((state) => state.adicciones);

  const cleanState = () => {    
    dispatch(setActiveStepAdicciones(STEPPER_ADICCIONES.BUSCADOR));
    dispatch(cleanAfiliadoSeleccionadoAdicciones());
    dispatch(clearAdicciones());
  };

  useEffect(() => {
    if(!fromGestion)  cleanState();
  }, []);

  return (
    <>
      <Grid item xs={12}>
        <AdiccionesStepper activeStep={activeStep} />
      </Grid>
      {/* {activeStep === STEPPER_INTEGRACION.DATOS_AFILIADO && (
        <Grid item xs={12}>
          <IntegracionAccordionHistorialConsumos />
        </Grid>
      )} */}
      <Grid item xs={11}>
        {activeStep === STEPPER_ADICCIONES.BUSCAR_AFILIADO && (
          <AutorizacionesBuscador integracion={false} /*tipoBusqueda={'Discapacitados'}*/ adicciones={true}/>
        )}
        {activeStep === STEPPER_ADICCIONES.DATOS_AFILIADO && (
          <AdiccionesDatosTitular integracion={false} nuevaSolic={true} adicciones={true}/>
        )}
        {activeStep === STEPPER_ADICCIONES.DETALLES_ORDEN && (
          <AdiccionesDetalleOrden />
        )}
        {activeStep === STEPPER_ADICCIONES.COMPLEMENTO_ORDEN && (
          <AdiccionesComplementoOrden />
        )}
        {activeStep === STEPPER_ADICCIONES.DIAGNOSTICO_DOCUMENTACION && (
          <AdiccionesDiagnosticoDocumentacion />
        )}
        {activeStep === STEPPER_ADICCIONES.PRACTICAS && (
          <AdiccionesPracticas />
        )}        
      </Grid>

    </>
  );
};
